import { render, staticRenderFns } from "./SanteActifs.vue?vue&type=template&id=08997f42&scoped=true&"
import script from "./SanteActifs.vue?vue&type=script&lang=js&"
export * from "./SanteActifs.vue?vue&type=script&lang=js&"
import style0 from "./SanteActifs.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SanteActifs.vue?vue&type=style&index=1&id=08997f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08997f42",
  null
  
)

export default component.exports